import { pactureLogoURL } from "../../shared/pactureLogo";

export function PactureLogo({ className }: { className?: string }) {
  return <img className={className} src={pactureLogoURL} alt="" aria-hidden="true" />;
}
